import { DomainConfig } from 'libs/config';
import {
  acmeChartPalette,
  acmeDarkPalette,
  acmeLightPalette,
} from 'libs/domain/acme/palettes';
import authBg from './assets/authbg.png';
import logo from './assets/logo.svg?react';

const acmeDomainTemplate = {
  // When the key value below is also set in the env variable `VITE_ENABLE_CUSTOM_DOMAINS`, we will
  // apply the below domain configuration.
  clientId: '712', // Set to KORTXIO. it will allow adminswith clientId 712 when the domains matches.
  palettes: {
    lightPalette: acmeLightPalette,
    darkPalette: acmeDarkPalette,
    chartPalette: acmeChartPalette,
  },
  assets: {
    logo,
    authBg,
  },
};

// The acmeDomainConfig is our test domain, it can be used for testing and as a template for new domain settings.
const acmeDomainConfig: (k: string) => DomainConfig[] = (key: string) => [
  {
    key,
    ...acmeDomainTemplate,
  },
  {
    key: `${key}-test`,
    ...acmeDomainTemplate,
  },
  {
    key: `${key}-uat`,
    ...acmeDomainTemplate,
  },
];

export default acmeDomainConfig;
